// french translations
export default {
  "Learn more": "Learn more",
  "Photo courtesy of": "Photo courtesy of",
  Explore: "Explore",
};
